import moment from 'moment'
import React, { useCallback } from 'react'
import Link from 'redux-first-router-link'

import ManagedAccordion from 'shared/components/ui/ManagedAccordion'
import { Loader, Menu } from 'util/ui'

import Actions from '../../../shared/LinkedResource/Actions'
import Key from '../../../shared/LinkedResource/Key'
import Row from '../../../shared/LinkedResource/Row'
import Title from '../../../shared/LinkedResource/Title'

const LOCK_TRANSLATIONS = {
  TOO_HEATED: 'Too heated',
  OFF_TOPIC: 'Off topic',
  RESOLVED: 'Resolved',
  SPAM: 'Spam',
}
function formatDate(date) {
  if (!date) return ''
  const asDate = new Date(date)
  const displayYear = asDate.getFullYear() !== new Date().getFullYear()
  return moment(date).format(`D MMM${displayYear ? " 'YY" : ''}, H:mmA`)
}
export default function LinkedGitHubIssue({
  issue,
  issue: {
    activeLockReason,
    assignees = [],
    createdAt,
    errored,
    id,
    labels = [],
    loaded,
    locked,
    milestone,
    repository: { nameWithOwner: repoName, url: repoUrl } = {},
    state,
    title,
    updatedAt,
    url,
  } = {},
  initiallyActive,
  fieldsToDisplay: {
    assignees: displayAssignees,
    created: displayCreatedAt,
    labels: displayLabels,
    locked: displayLocked,
    milestone: displayMilestone,
    repository: displayRepo,
    state: displayState,
    updated: displayUpdatedAt,
  },
  onSetState,
  onUnlink,
}) {
  const { title: milestoneTitle, url: milestoneUrl } = milestone || {}
  const isOpen = state === 'OPEN'
  const onToggleState = useCallback(
    () => onSetState(id, isOpen ? 'CLOSED' : 'OPEN'),
    [id, isOpen]
  )
  return (
    <ManagedAccordion
      as={Menu}
      collapsed
      fluid
      initiallyActive={initiallyActive}
      styled
      title={<Title>{title}</Title>}
      vertical
    >
      {(!issue || !loaded) && <Loader active inline="centered" />}
      {issue &&
        loaded && (
          <React.Fragment>
            <Row>
              <Key>Issue: </Key>
              <Link target="_blank" to={url}>
                {title}
              </Link>
            </Row>
            {!errored && (
              <React.Fragment>
                {displayRepo && (
                  <Row>
                    <Key>Repository: </Key>
                    <Link target="_blank" to={repoUrl}>
                      {repoName}
                    </Link>
                  </Row>
                )}
                {displayState && (
                  <Row>
                    <Key>State: </Key>
                    {isOpen ? 'Open' : 'Closed'}
                  </Row>
                )}
                {displayAssignees &&
                  assignees.length > 0 && (
                    <Row>
                      <Key>Assignees: </Key>
                      {assignees.map(({ login, url: assigneeUrl }, i) => [
                        i === 0 ? null : ', ',
                        <Link key={login} target="_blank" to={assigneeUrl}>
                          {login}
                        </Link>,
                      ])}
                    </Row>
                  )}
                {displayLabels &&
                  labels.length > 0 && (
                    <Row>
                      <Key>Labels: </Key>
                      {[
                        ...labels.map(({ name, url: labelUrl }, i) => [
                          i === 0 ? null : ', ',
                          <Link target="_blank" to={labelUrl}>
                            {name}
                          </Link>,
                        ]),
                      ]}
                    </Row>
                  )}
                {displayCreatedAt && (
                  <Row>
                    <Key>Created: </Key>
                    {formatDate(createdAt)}
                  </Row>
                )}
                {displayUpdatedAt && (
                  <Row>
                    <Key>Last updated: </Key>
                    {formatDate(updatedAt)}
                  </Row>
                )}
                {displayMilestone &&
                  milestone && (
                    <Row>
                      <Key>Milestone: </Key>
                      <Link target="_blank" to={milestoneUrl}>
                        {milestoneTitle}
                      </Link>
                    </Row>
                  )}
                {displayLocked && (
                  <Row>
                    <Key>Locked: </Key>
                    {locked ? LOCK_TRANSLATIONS[activeLockReason] : 'Unlocked'}
                  </Row>
                )}
              </React.Fragment>
            )}
            <Actions
              id={id}
              actions={[
                {
                  action: () => onUnlink(id, title, url),
                  icon: 'unlink',
                  text: 'Unlink',
                },
                !errored && {
                  action: onToggleState,
                  text: isOpen ? 'Close' : 'Open',
                },
              ]}
            />
          </React.Fragment>
        )}
    </ManagedAccordion>
  )
}
